export default "{\n    \"noOptions\": \"No se encontraron direcciones\"\n}\n"